import { Popconfirm, Space, Tooltip } from "antd"
import { Button } from "src/components/actions/button"
import { PencilSvg, TrashSvg } from "src/components/Svg"

export function getColumns(onEdit, onDelete) {
  return [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      sorter: (a, b) => a.id - b.id,
      defaultSortOrder: "ascend",
    },
    {
      title: "Заголовок",
      dataIndex: "titleRu",
      key: "titleRu",
      sorter: (a, b) =>
        String(a.titleRu).localeCompare(String(b.titleRu), "ru"),
    },
    {
      title: "Slug",
      dataIndex: "slug",
      key: "slug",
      sorter: (a, b) => String(a.slug).localeCompare(String(b.slug)),
    },
    {
      title: "Позиция",
      dataIndex: "sortWeight",
      key: "sortWeight",
      sorter: (a, b) => a.sortWeight - b.sortWeight,
    },
    {
      title: "Подразделов",
      dataIndex: "sections",
      key: "sectionsCount",
      render: (sections) => (Array.isArray(sections) ? sections.length : 0),
    },
    ...(onEdit || onDelete
      ? [
          {
            title: "Действие",
            key: "action",
            render: (_, record) => (
              <Space size="small">
                {onEdit && (
                  <Tooltip
                    placement="top"
                    title="Редактировать"
                    mouseLeaveDelay={0}
                  >
                    <Button
                      size="small"
                      type="link"
                      onClick={() => onEdit(record.id)}
                    >
                      <PencilSvg />
                    </Button>
                  </Tooltip>
                )}
                {onDelete && (
                  <Tooltip placement="top" title="Удалить" mouseLeaveDelay={0}>
                    <Popconfirm
                      placement="left"
                      title="Действительно хотите удалить?"
                      onConfirm={() => onDelete(record.id)}
                      onCancel={stopPropagation}
                    >
                      <Button size="small" type="link" onClick={stopPropagation}>
                        <TrashSvg />
                      </Button>
                    </Popconfirm>
                  </Tooltip>
                )}
              </Space>
            ),
          },
        ]
      : []),
  ]
}

const stopPropagation = (e) => {
  e?.stopPropagation()
}
